import React, { useState } from 'react';

const EditableTextInput = ({ initialValue = '', name, onSave, className }) => {
	const [isEditing, setIsEditing] = useState(false);
	const [value, setValue] = useState(initialValue);
	const [tempValue, setTempValue] = useState(initialValue);
	

	const handleEdit = () => {
		setTempValue(value);
		setIsEditing(true);
	};

	const handleSave = () => {
		if (tempValue.trim() === '') {
			// Prevent saving empty value
			toast.error('Value cannot be empty.');
			return;
		}
	
		setValue(tempValue);
		setIsEditing(false);
		if (onSave) onSave(tempValue);
	};

	const handleCancel = () => {
		setTempValue(value);
		setIsEditing(false);
	};

	return (
		<div className={`flex items-center gap-2 relative ${className} group`}>
			{isEditing ? (
				<>
					<input
						type="text"
						className="input-field"
						value={tempValue}
						onChange={(e) => setTempValue(e.target.value)}
						autoFocus={true}
					/>
					<button
						onClick={handleSave}
						className="bg-transparent border-none cursor-pointer text-primary"
					>
						<span className="material-symbols-rounded text-lg">check</span>
					</button>
					<span className='w-[2px] h-[20px] bg-grey'></span>
					<button
						onClick={handleCancel}
						className="bg-transparent border-none cursor-pointer text-secondary"
					>
						<span className="material-symbols-rounded text-lg">close</span>
					</button>
				</>
			) : (
				<>
					<span>{value}</span>
					<button
						onClick={handleEdit}
						className="edit-button bg-transparent text-grey border-none cursor-pointer flex items-center absolute right-[-24px] opacity-0 transition-opacity duration-200 group-hover:opacity-100"
					>
						<span className="fk-icons text-lg">edit</span>
					</button>
					<input type="hidden"
						name={name}
						value={value}
					/>
				</>
			)}
		</div>
	);
};

export default EditableTextInput;